
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Factories from "./pages/Factories";
import Categories from "./pages/Categories";
import Variants from "./pages/Variants";
import VariantOptions from "./pages/VariantOptions";
import Customers from "./pages/Customers";
import Billing from "./pages/Billing";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import Index from "./pages/Index";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import VariantMeasurements from "@/pages/VariantMeasurements";

// Import RemixIcon CSS
import "remixicon/fonts/remixicon.css";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            
            {/* Auth routes */}
            <Route path="/auth/sign-in" element={<SignIn />} />
            <Route path="/auth/sign-up" element={<SignUp />} />
            <Route path="/auth/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/reset-password" element={<ResetPassword />} />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Dashboard />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/orders" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Orders />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/factories" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Factories />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/categories" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Categories />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/variants" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Variants />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/variant-options" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <VariantOptions />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/variant-measurements" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <VariantMeasurements />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/customers" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Customers />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/billing" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Billing />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/reports" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Reports />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Settings />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Profile />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
